module.exports = __webpack_public_path__ + "static/media/mediaWhite.b43f3061.svg";